import { render, staticRenderFns } from "./OdemeEmri163Taslak.vue?vue&type=template&id=8b5c3c5c"
import script from "./OdemeEmri163Taslak.vue?vue&type=script&lang=ts"
export * from "./OdemeEmri163Taslak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports